import React from 'react';
import { MapPin, Navigation, Clock } from 'lucide-react';

const LocationMap = () => {
  // Coordonnées de Creutzwald (à ajuster selon votre adresse exacte)
  const address = "Creutzwald, 57150, France";
  const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=JC+Performance+57+Creutzwald`;
  const wazeUrl = `https://waze.com/ul?q=Creutzwald+57150`;

  return (
    <section className="py-20 px-4 bg-gradient-to-b from-slate-900 to-slate-950" id="localisation">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            📍 Où nous trouver ?
          </h2>
          <p className="text-gray-400 text-lg">
            Atelier situé à Creutzwald (57) - Intervention sur place ou à domicile
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Map */}
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border-2 border-slate-700 h-96">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d41676.89585468842!2d6.688826!3d49.206667!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4794d93c7f8a8c85%3A0x40a5fb99a3b2a80!2s57150%20Creutzwald!5e0!3m2!1sfr!2sfr!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="JC Performance-57 Location"
            ></iframe>
          </div>

          {/* Info Cards */}
          <div className="space-y-6">
            {/* Adresse */}
            <div className="bg-slate-800/50 backdrop-blur-sm p-6 rounded-xl border-2 border-slate-700 hover:border-red-600 transition-all">
              <div className="flex items-start space-x-4">
                <div className="p-3 bg-red-600 rounded-lg">
                  <MapPin className="h-6 w-6 text-white" />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-white mb-2">Adresse</h3>
                  <p className="text-gray-300">
                    Creutzwald, 57150<br />
                    Moselle, Grand Est
                  </p>
                  <a
                    href={googleMapsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-red-600 hover:text-red-500 font-semibold mt-3 transition-colors"
                  >
                    <Navigation className="h-4 w-4 mr-2" />
                    Obtenir l'itinéraire
                  </a>
                </div>
              </div>
            </div>

            {/* Horaires */}
            <div className="bg-slate-800/50 backdrop-blur-sm p-6 rounded-xl border-2 border-slate-700 hover:border-red-600 transition-all">
              <div className="flex items-start space-x-4">
                <div className="p-3 bg-blue-600 rounded-lg">
                  <Clock className="h-6 w-6 text-white" />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-white mb-3">Horaires d'ouverture</h3>
                  <div className="space-y-2 text-gray-300">
                    <div className="flex justify-between">
                      <span>Lundi - Vendredi</span>
                      <span className="font-semibold text-white">9h - 18h</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Samedi</span>
                      <span className="font-semibold text-white">9h - 12h</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Dimanche</span>
                      <span className="font-semibold text-red-600">Fermé</span>
                    </div>
                  </div>
                  <p className="text-sm text-gray-400 mt-3">
                    📞 Intervention sur RDV uniquement
                  </p>
                </div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href={googleMapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 flex items-center justify-center bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-4 rounded-xl transition-all transform hover:scale-105"
              >
                <MapPin className="h-5 w-5 mr-2" />
                Google Maps
              </a>
              <a
                href={wazeUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 flex items-center justify-center bg-cyan-600 hover:bg-cyan-700 text-white font-semibold px-6 py-4 rounded-xl transition-all transform hover:scale-105"
              >
                <Navigation className="h-5 w-5 mr-2" />
                Waze
              </a>
            </div>
          </div>
        </div>

        {/* Zone d'intervention */}
        <div className="mt-12 text-center p-8 bg-gradient-to-r from-red-900/20 to-red-700/20 rounded-2xl border-2 border-red-700/50">
          <h3 className="text-2xl font-bold text-white mb-4">
            🚗 Zone d'intervention élargie
          </h3>
          <p className="text-gray-300 text-lg">
            Nous intervenons également à <span className="text-red-600 font-semibold">domicile</span> dans un rayon de 30 km autour de Creutzwald
          </p>
          <p className="text-gray-400 mt-2">
            Metz • Forbach • Sarreguemines • Saint-Avold • Thionville
          </p>
        </div>
      </div>
    </section>
  );
};

export default LocationMap;
